/* GEModal v2.0.0
 * Exposes the Gecko Modal class.
 */

import * as $ from "jquery";

import Blackout from "./Blackout";

export default class GEModal {
	element: JQuery;

	/**
	 * Creates a new GEModal with the given container.
	 * @param element The element to create the modal with.
	 */
	constructor(element: JQuery) {
		this.element = element;
	}

	/**
	 * Destroys the modal and removes it from the list of created modals.
	 */
	destroy(): void {
		let newModals = [];

		Blackout.unuse(this);
	}

	/**
	 * Returns whether the modal is active.
	 */
	isActive(): boolean {
		return this.element.hasClass("active");
	}

	/**
	 * Shows the modal.
	 */
	show(): void {
		this.element.addClass("active");
		Blackout.use(this);
	}

	/**
	 * Hides the modal.
	 */
	hide(): void {
		this.element.removeClass("active");
		Blackout.unuse(this);
	}

	/**
	 * Hides the modal.
	 * Returns the new state of the modal.
	 */
	toggle(): boolean {
		if (this.element.hasClass("active")) {
			this.hide();

			return false;
		} else {
			this.show();

			return true;
		}
	}
}